/**
 * getticketequipamentos returns { equipamentos, equipamentos_do_kit } (or legacy bare array).
 */
export function normalizeGetTicketEquipamentosResponse(data) {
    if (data == null || typeof data !== 'object') {
        return { equipamentos: [], equipamentos_do_kit: [] };
    }
    if (data.erro) {
        return { equipamentos: [], equipamentos_do_kit: [] };
    }
    if (Array.isArray(data)) {
        return { equipamentos: data, equipamentos_do_kit: [] };
    }
    return {
        equipamentos: Array.isArray(data.equipamentos) ? data.equipamentos : [],
        equipamentos_do_kit: Array.isArray(data.equipamentos_do_kit) ? data.equipamentos_do_kit : []
    };
}
